import { logger } from '@modules/logger';
import { createContext } from 'react';

const initialContext = {
  activeId: undefined,
  requestToMakeActive: () => logger.warn('requestToMakeActive not provided for singletonContext'),
  makeInactive: () => logger.warn('makeInactive not provided for singletonContext'),
  lock: () => logger.warn('lock not provided for singletonContext'),
  unlock: () => logger.warn('unlock not provided for singletonContext'),
};

type OnUnlockOptions =
  | {
      command: 'make-inactive';
    }
  | {
      command: 'activate';
      id: string;
    }
  | {
      command: 'activate-last-request';
    };

interface singletonContextValues {
  activeId?: string;
  requestToMakeActive: (id: string) => void;
  makeInactive: (id?: string) => void;
  lock: (makeInactive?: boolean) => void;
  unlock: (options?: OnUnlockOptions) => void;
}

const contexts: { [key: string]: React.Context<singletonContextValues> } = {};

const getOrCreateContext = (id: string): React.Context<singletonContextValues> => {
  if (contexts[id]) return contexts[id];
  const context = createContext<singletonContextValues>(initialContext);
  contexts[id] = context;

  return context;
};

export { getOrCreateContext };
export type { singletonContextValues };
